import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy
} from '@angular/core';
import { ActionModel } from '../action.model';
import { ActionsService } from '../actions.service';
import { UserPublicProfileComponent } from '../../shared/user-public-profile/user-public-profile.component';
import { UtilsService } from '../../shared/utils.service';
import { AssetsViewComponent } from '../../assets/assets-view/assets-view.component';

@Component({
  selector: 'app-actions-view',
  templateUrl: './actions-view.component.html',
  styleUrls: ['./actions-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ActionsViewComponent implements OnInit {
  @Input() action: ActionModel;
  @Input() hide_asset_link: boolean = false;

  constructor(public utils: UtilsService) {}

  ngOnInit() {}

  onUserPublicView(hash: string) {
    this.utils.showComponentDialog(
      UserPublicProfileComponent,
      hash,
      { width: '90%' },
      () => {
        // Refresh the list regardless of how the dialog is closed.
      }
    );
  }

  /**
   * Open the asset view dialog for an asset that a task originated from.
   *
   * @param {number} asset_id - The id of the asset to view.
   * @return {void}
   */
  onViewAsset(asset_id: number): void {
    this.utils.showComponentDialog(
      AssetsViewComponent,
      { asset_id: asset_id },
      { width: '90%' }
    );
  }
}
